// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import {ButtonLink} from 'sail/Button';
import {webhook} from 'sail/Icon/Assets';
import {CompactTooltip} from 'sail/Tooltip';
import {renderMarkdocAsReact} from 'docs/markdoc';
import type {RenderNodes} from '@markdoc/markdoc';
import {ACTION_NODE_WIDTH, ACTION_NODE_HEIGHT} from './SequenceDiagram';

import './SequenceDiagram.scss';

type SequenceDiagramActionNodeData = {|
  text: RenderNodes,
  event?: string,
  span?: number,
|};

type SequenceDiagramActionNodeProps = {|
  data: SequenceDiagramActionNodeData,
|};

export const SequenceDiagramActionNode = ({
  data,
}: SequenceDiagramActionNodeProps) => {
  const {event, text} = data;
  const span = data.span || 1;

  return (
    <Box
      className="SequenceDiagramActionNode"
      flex={{alignItems: 'center', justifyContent: 'center'}}
      style={{
        width: `${ACTION_NODE_WIDTH * span}px`,
        height: `${ACTION_NODE_HEIGHT}px`,
      }}
    >
      <Handle
        type="target"
        id="top"
        position={Position.Top}
        style={{top: '0%', left: '50%'}}
      />
      <Handle
        type="target"
        id="left"
        position={Position.Left}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Left}
        id="left"
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        style={{left: '50%', top: '100%'}}
      />
      <Box flexBasis="100%" padding={{horizontal: 16}}>
        {' '}
        <BodyAlt align="center">
          {React.Children.toArray(renderMarkdocAsReact(text))}
        </BodyAlt>
        {event && (
          <Box className="SequenceDiagramActionNode-event">
            <CompactTooltip
              context={
                <ButtonLink
                  color="gray900"
                  icon={webhook}
                  label={event}
                  hideLabel
                />
              }
              label={event}
            />
          </Box>
        )}
      </Box>
      <Handle
        type="target"
        id="right"
        position={Position.Right}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{top: '50%'}}
      />
    </Box>
  );
};
